<span class="input-group-btn">
  <button class="btn toggle-button" [class.active]="controls.highlightOptionsOpen" [disabled]="disabled"
    (click)="toggleHighlightOptionsOpen()" style="text-align: left;" [style.width]="isMobile() ? '45px !important' : '115px !important'" [style.padding]="isMobile() ? '5px 6px' : ''">
    @if (!isMobile()) {
      Highlight&nbsp;
    } @else if (!displayable.displayOptions.cosmeticOptions?.highlight) {
      <span class="icon icon-eye"></span>
    }
    <app-minimap-icon [cosmeticOptions]="displayable.displayOptions.cosmeticOptions"></app-minimap-icon>
    @if (displayable.displayOptions.cosmeticOptions?.highlight && displayable.displayOptions.cosmeticOptions?.beam) {
      <app-highlight-beam-icon [highlightColor]="displayable.displayOptions.cosmeticOptions!.highlightColor!"></app-highlight-beam-icon>
    }
  </button>
  <button class="btn toggle-button" [class.active]="controls.soundOptionsOpen" [disabled]="disabled"
    (click)="toggleSoundOptionsOpen()" style="text-align: left;" [style.width]="isMobile() ? '45px !important' : '100px !important'">
    @if (!isMobile()) {
      Sound
    } @else {
      S
    }
    @if (displayable.displayOptions.cosmeticOptions?.alertSound && displayable.displayOptions.cosmeticOptions?.customAlertSound) {
      (✓)
    } @else if (displayable.displayOptions.cosmeticOptions?.alertSound && displayable.displayOptions.cosmeticOptions?.alertSoundSound?.startsWith('S')) {
      (✓)
    } @else if (displayable.displayOptions.cosmeticOptions?.alertSound && displayable.displayOptions.cosmeticOptions?.alertSoundSound) {
      ({{ displayable.displayOptions.cosmeticOptions?.alertSoundSound }})
    }
  </button>

  <button class="btn toggle-button" style="padding: 0px !important;" [disabled]="disabled" (click)="controls.labelOptionsOpen = !controls.labelOptionsOpen;">
    <div app-label-viewer [displayOptions]="displayable.displayOptions" [forceHidden]="forceHidden" [exampleName]="isMobile() ? exampleName?.slice(0, 1) : exampleName" [clickable]="true"
      [isDivinationCard]="isDivinationCard" [isPoe1Gem]="isPoe1Gem" [isCurrency]="isCurrency" [isWaystone]="isWaystone" [rarity]="rarity" [sockets]="sockets"
      [influence]="influence" [fractured]="fractured" [synthesised]="synthesised" [veiled]="veiled" [dirtyForceUpdate]="dirtyForceUpdate"></div>
  </button>
</span>
